import { CheckCircle2, XCircle } from 'lucide-react';
import { Checkbox } from '@/components/ui/checkbox';
import { ETHOS_IS, ETHOS_ISNT, ETHOS_CLOSE, FBC_PROMISES, FBC_NOT_PROMISES } from '@/lib/ethosCopy';

// "What FBC is. And what it isn't." Optional "I understand" tick for sign-up.
export default function IsIsntCard({ compact = false, ack, onAckChange, className = '' }) {
  return (
    <section className={`rounded-xl border bg-card p-4 sm:p-5 space-y-3 ${className}`} data-testid="is-isnt-card">
      <h3 className="font-semibold text-base sm:text-lg" style={{ fontFamily: 'Playfair Display, serif' }}>What FBC is. And what it isn't.</h3>
      <p className="text-sm leading-relaxed">{ETHOS_IS}</p>
      <p className="text-sm leading-relaxed text-muted-foreground">{ETHOS_ISNT}</p>
      {!compact && (
        <div className="grid sm:grid-cols-2 gap-3 pt-1">
          <List title="FBC offers" items={FBC_PROMISES} Icon={CheckCircle2} tone="text-emerald-600" testid="is-list" />
          <List title="FBC does not offer" items={FBC_NOT_PROMISES} Icon={XCircle} tone="text-rose-500" testid="isnt-list" />
        </div>
      )}
      <p className="text-sm italic">{ETHOS_CLOSE}</p>
      {onAckChange && (
        <label className="flex items-start gap-2 rounded-md border bg-muted/40 p-2.5 cursor-pointer" data-testid="ethos-ack-label">
          <Checkbox checked={!!ack} onCheckedChange={(v) => onAckChange(!!v)} className="mt-0.5" data-testid="ethos-ack-checkbox" />
          <span className="text-sm font-medium">I understand what FBC is and what it isn't.</span>
        </label>
      )}
    </section>
  );
}

function List({ title, items, Icon, tone, testid }) {
  return (
    <div data-testid={testid}>
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-1.5">{title}</p>
      <ul className="space-y-1">
        {items.map((t) => <li key={t} className="flex items-start gap-1.5 text-sm"><Icon className={`h-4 w-4 shrink-0 mt-0.5 ${tone}`} />{t}</li>)}
      </ul>
    </div>
  );
}
